import { mount } from 'svelte'
import './app.css'
import { initSentry } from './lib/sentry.js'
import { startTitleGlitch } from './lib/os/title-glitch.js'
import App from './App.svelte'

initSentry()
startTitleGlitch()

const app = mount(App, {
  target: document.getElementById('app'),
})

export default app
